import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { KnownSelectorComponent } from './components/known-selector/known-selector.component';
import { KnownService } from './services/known.service';

@NgModule({

    declarations: [
        KnownSelectorComponent
    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    exports: [
        KnownSelectorComponent
    ],

    providers: [
        KnownService
    ]

})
export class KnownsModule { }
